// Labels shown in the "Document" section of the QR validator. Keys must match the
// document_type / judgment_type / notification_delivery values returned by the core
// document validation endpoint.

const JUDGMENT_SUBTYPE_LABELS = {
  definitive: 'Sentencia definitiva',
  interlocutory: 'Sentencia interlocutoria',
  second_instance: 'Sentencia de segunda instancia',
};

const NOTIFICATION_DELIVERY_LABELS = {
  electronic: 'Notificación electrónica',
  personal: 'Notificación personal',
};

const DOCUMENT_TYPE_LABELS = {
  agreement: 'Acuerdo',
  annexe: 'Anexo',
  notification: 'Notificación',
  judgment: 'Sentencia',
  promotion: 'Promoción',
  first_demand: 'Primera demanda',
  first_document: 'Primer documento',
  demand: 'Demanda',
  demand_annexe: 'Anexo',
  writ: 'Oficio',
  audience: 'Audiencia',
  amparo: 'Demanda de amparo',
  constancy: 'Constancia',
  recordAudience: 'Constancia de celebración de audiencia',
  diligence: 'Acta de diligencia',
  subpoena: 'Citatorio',
  ack: 'Acuse de Apelación Electrónica',
  neas: 'Acuse de Apelación Electrónica Turnada',
  'Copia certificada': 'Copia certificada',
  'Copia simple': 'Copia simple',
  Original: 'Original',
  privateJudgment: 'Sentencia Privada',
  email: 'Correo Electrónico',
  Correo: 'Correo Electrónico',
  convention: 'Convenio',
  certification: 'Certificación',
};

export const DEFAULT_DOCUMENT_TYPE_LABEL = 'Documento';

/**
 * Resolves the visible label of a document type. Judgments use their subtype label and
 * notifications their delivery channel label when known; otherwise the generic type label.
 *
 * @param {string} type document_type returned by the API.
 * @param {?string} [judgmentSubtype] judgment_type returned by the API.
 * @param {?string} [notificationDelivery] notification_delivery returned by the API.
 * @returns {string} Label to display.
 */
// Own keys only, so values like "toString" or "constructor" never resolve to
// properties inherited from Object.prototype.
const ownLabel = (labels, key) =>
  Object.prototype.hasOwnProperty.call(labels, key) ? labels[key] : undefined;

export const getDocumentTypeName = (type, judgmentSubtype, notificationDelivery) => {
  if (type === 'judgment' && ownLabel(JUDGMENT_SUBTYPE_LABELS, judgmentSubtype)) {
    return ownLabel(JUDGMENT_SUBTYPE_LABELS, judgmentSubtype);
  }

  if (type === 'notification' && ownLabel(NOTIFICATION_DELIVERY_LABELS, notificationDelivery)) {
    return ownLabel(NOTIFICATION_DELIVERY_LABELS, notificationDelivery);
  }

  return ownLabel(DOCUMENT_TYPE_LABELS, type) || DEFAULT_DOCUMENT_TYPE_LABEL;
};

export const INVALID_QR_MESSAGE = 'QR inválido. Verifique el código';
